var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07589 8.97839L2.66262 6.15279C1.18336 3.1952 0.443252 1.71593 1.12302 1.03616C1.80184 0.35734 3.28205 1.0965 6.23964 2.57577L16.9415 7.92621C19.0232 8.96707 20.0641 9.4875 20.0641 10.3115C20.0641 11.1355 19.0232 11.656 16.9434 12.6968L6.23964 18.0473C3.28205 19.5265 1.80278 20.2666 1.12302 19.5869C0.444195 18.908 1.18336 17.4278 2.66262 14.4702L4.07401 11.6446L12.284 11.6447C12.6335 11.6386 12.9667 11.4954 13.2118 11.2461C13.4568 10.9968 13.5942 10.6611 13.5942 10.3115C13.5942 9.96191 13.4568 9.62629 13.2118 9.37694C12.9667 9.12759 12.6335 8.98446 12.284 8.97839L4.07589 8.97839Z",
    fill: "#3253DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter1);
export default __webpack_public_path__ + "static/media/enter1.9ac1e72e5bc65fe4a28ceb78dd0e7572.svg";
export { ForwardRef as ReactComponent };